export const mergeConversationPages = (existing = [], incoming = [], { args, readField }) => {
  const offset = args?.offset ?? 0;
  const merged = offset === 0 ? [] : existing.slice();

  for (let index = 0; index < incoming.length; index++) {
    merged[offset + index] = incoming[index];
  }

  const seen = new Set();
  return merged.filter((reference) => {
    const id = readField("id", reference);
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};
